/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Erp_Again_QInputs */



/**
* | output |
* | --- |
* | "Can I download earlier dates again?" |
*
* @param {Partner_Faq_Erp_Again_QInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_erp_again_q = /** @type {((inputs?: Partner_Faq_Erp_Again_QInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Erp_Again_QInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kann ich frühere Zeiträume erneut herunterladen?")
	return /** @type {LocalizedString} */ ("Can I download earlier dates again?")
});